import React from "react";

const CostLogContext = React.createContext({});

export default CostLogContext;
